import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { AccessReducer } from "redux/reducers/Access";
import { SettingReducer } from "redux/reducers/Setting";
import { MasterReducer } from "./../reducers/Master";

const rootReducer = combineReducers({
  master: MasterReducer,
  access: AccessReducer,
  setting: SettingReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
